import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const unhideTestStep = async ({ testStepId }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No User details found in localStorage");

  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=unhideTestStep&companyid=${user.companyid}&tsid=${testStepId}`,
  );
  return response.data;
};

const useUnhideTestStepMutation = () => {
  return useMutation({
    mutationFn: unhideTestStep,
  });
};

export default useUnhideTestStepMutation;
